import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./styles/financialItemStyle";
import "../Print.css";

type ForeignCurrencyDataProps = {
  foreignCurrencyData: Array<object>;
  foreignCurrencyTotal: string;
  localForeignCurrencyTotal: string;
  source: string;
};

export const ForeignCurrency: FunctionComponent<ForeignCurrencyDataProps> = ({
  foreignCurrencyData,
  foreignCurrencyTotal,
  localForeignCurrencyTotal,
  source,
}) => {
  const classes = financialItemStyles();

  return (
    <Grid container style={{ paddingTop: "2.4em" }}>
      <Grid item xs={12}>
        <TableContainer>
          <Grid container>
            <Grid item lg={12}>
              <Typography className={classes.title}>
                Foreign Currency
              </Typography>
            </Grid>
          </Grid>
          <Table
            size="small"
            aria-label="a dense table"
            className={source === "print" ? classes.table : ""}
          >
            <TableHead className={classes.tableRow}>
              <TableRow>
                <TableCell
                  align="left"
                  className={classes.headColor}
                  component="th"
                  scope="row"
                  // style={{ width: "30%" }}
                ></TableCell>

                {/* <TableCell align="right" className={classes.headCell}>
                  Count
                </TableCell> */}
                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Bills
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {foreignCurrencyData &&
                foreignCurrencyData.map((data: any) => (
                  <TableRow>
                    <TableCell align="left" className={classes.headColor}>
                      {data.currency_name}
                    </TableCell>
                    <TableCell align="right" className={classes.headColor}>
                      {data.FcurrencyCount ? data.FcurrencyCount : "0"}
                    </TableCell>
                    {/* <TableCell align="right" className={classes.headColor}>
                      {"0.00"}
                    </TableCell> */}
                    <TableCell align="right" className={classes.headColor}>
                      {data.FcurrencyAmount ? data.FcurrencyAmount : "0.00"}
                    </TableCell>
                  </TableRow>
                ))}

              <TableRow>
                <TableCell
                  align="left"
                  className={classes.headCell}
                  colSpan={2}
                >
                  Total
                </TableCell>
                <TableCell align="right" className={classes.headCell}>
                  {" "}
                  {foreignCurrencyTotal ? foreignCurrencyTotal : "0.00"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
